import React from 'react'
import { Chart } from 'react-google-charts'

const formatBRL = (val) => {
  const n = parseFloat(String(val || 0).replace(',', '.'))
  return isNaN(n) ? 'R$ 0,00' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

const CORES_PADRAO = ['#FF6A00', '#6f42c1', '#28a745', '#17a2b8', '#ffc107', '#dc3545', '#0dcaf0', '#fd7e14', '#20c997']

const SemDados = ({ icone }) => (
  <div style={{ textAlign: 'center', color: '#bbb', padding: '40px 0' }}>
    <i className="material-icons" style={{ fontSize: 34 }}>{icone || 'bar_chart'}</i>
    <p style={{ fontSize: 12, marginTop: 6 }}>Sem dados no período</p>
  </div>
)

const Carregando = () => (
  <span className="vx-skeleton" style={{ height: 260, display: 'block' }}>&nbsp;</span>
)

const tooltipBase = (nome, extra) =>
  '<div style="padding:10px 14px;font-size:12px;min-width:180px;font-family:sans-serif;">' +
  `<strong style="display:block;margin-bottom:6px;color:#333;">${nome}</strong>` +
  extra +
  '</div>'

/* ────────────────────────────────────────────
   1. Vendas por Dia (ComboChart)
   fonte: bi.totalAgrupadoPorSituacao
─────────────────────────────────────────────*/
export const GraficoVendasPorDia = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => it.periodo)
  if (!lista.length) return <SemDados icone="show_chart" />

  const data = [
    ['Dia', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } },
      'Cancelamentos (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const cancel = parseFloat(it.valorTotalCancelamentos || 0)
      return [
        it.periodo,
        venda,
        tooltipBase(it.periodo,
          `<span style="color:#666;">(Vendas=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}`
        ),
        cancel,
        tooltipBase(it.periodo + ' — Cancelamentos',
          `<span style="color:#666;">(Q.Canc.=): </span>${it.quantidadeCancelamentos || 0}<br/>` +
          `<span style="color:#666;">(V.Cancelado=): </span>${formatBRL(cancel)}`
        )
      ]
    })
  ]

  const options = {
    seriesType: 'bars',
    series: { 0: { color: '#FF6A00' }, 1: { type: 'line', color: '#dc3545' } },
    tooltip: { isHtml: true },
    legend: { position: 'top', textStyle: { fontSize: 11 } },
    hAxis: { textStyle: { fontSize: 10 } },
    vAxis: { format: 'short', textStyle: { fontSize: 10 } },
    chartArea: { width: '80%', height: '65%' },
    bar: { groupWidth: '60%' },
    height: 280
  }

  return (
    <Chart chartType="ComboChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   2. Fechamento de Caixa (PieChart)
   fonte: bi.totalFechamentoPorSituacao
─────────────────────────────────────────────*/
export const GraficoFechamentoCaixa = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => (it.quantidadeVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="payment" />

  const totalQtd = lista.reduce((s, it) => s + (it.quantidadeVendas || 0), 0)

  const data = [
    ['Situação', 'Quantidade', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const pct = totalQtd ? ((it.quantidadeVendas / totalQtd) * 100).toFixed(1) : '0'
      return [
        it.nome,
        it.quantidadeVendas,
        tooltipBase(it.nome,
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(T.Vendas=): </span>${formatBRL(it.valorTotalVendas)}<br/>` +
          `<span style="color:#666;">(Depósito=): </span>${formatBRL(it.totalDeposito)}<br/>` +
          `<span style="color:#666;">(Cartão=): </span>${formatBRL(it.totalRecebidoCartao)}<br/>` +
          `<span style="color:#666;">(PIX=): </span>${formatBRL(it.totalRecebidoPix)}<br/>` +
          `<span style="color:#666;">(Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        )
      ]
    })
  ]

  const options = {
    pieHole: 0.4,
    colors: CORES_PADRAO,
    tooltip: { isHtml: true },
    legend: { position: 'right', textStyle: { fontSize: 11 } },
    chartArea: { width: '90%', height: '80%' },
    height: 260
  }

  return (
    <Chart chartType="PieChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   3. Faturamento por Trecho (BarChart horizontal)
   fonte: bi.totalFaturamentoPorTrecho
─────────────────────────────────────────────*/
export const GraficoFaturamentoPorTrecho = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).slice(0, 10).filter(it => parseFloat(it.valorTotalVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="route" />

  const totalVendas = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  const data = [
    ['Trecho', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const pct = totalVendas ? ((venda / totalVendas) * 100).toFixed(1) : '0'
      return [
        it.nome,
        venda,
        tooltipBase(it.nome,
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(Q.Aprov=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(Q.Canc.=): </span>${it.quantidadeCancelamentos || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}<br/>` +
          `<span style="color:#666;">(V.Cancelado=): </span>${formatBRL(it.valorTotalCancelamentos)}<br/>` +
          `<span style="color:#666;">(L.Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        )
      ]
    })
  ]

  const options = {
    bars: 'horizontal',
    colors: ['#FF6A00'],
    tooltip: { isHtml: true },
    legend: { position: 'none' },
    hAxis: { format: 'short', textStyle: { fontSize: 10 } },
    vAxis: { textStyle: { fontSize: 10 } },
    chartArea: { width: '60%', height: '80%' },
    height: 280
  }

  return (
    <Chart chartType="BarChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   4. Tipo de Pagamento (PieChart)
   fonte: bi.totalFaturamentoPorFormaPagamento
─────────────────────────────────────────────*/
const LABELS_PAGAMENTO = {
  DINHEIRO: 'Dinheiro',
  CARTAO: 'Cartão',
  CARTAO_CREDITO: 'Crédito',
  CARTAO_DEBITO: 'Débito',
  PIX: 'PIX',
  TEF: 'TEF',
  LINK_PAGAMENTO: 'Link Pag.',
  CONTA_MERCADO_PAGO: 'Mercado Pago',
  BOLETO: 'Boleto'
}

export const GraficoTipoPagamento = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => parseFloat(it.valorTotalVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="credit_card" />

  const totalVendas = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  const data = [
    ['Pagamento', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const pct = totalVendas ? ((venda / totalVendas) * 100).toFixed(1) : '0'
      const label = LABELS_PAGAMENTO[it.nome] || it.nome
      return [
        label,
        venda,
        tooltipBase(label,
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(Q.Aprov=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}`
        )
      ]
    })
  ]

  const options = {
    pieHole: 0.4,
    colors: CORES_PADRAO,
    tooltip: { isHtml: true },
    legend: { position: 'right', textStyle: { fontSize: 11 } },
    chartArea: { width: '90%', height: '80%' },
    height: 260
  }

  return (
    <Chart chartType="PieChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   4b. Faturamento por Rota (PieChart)
   fonte: porRota (buscarBIVendedor)
─────────────────────────────────────────────*/
export const GraficoFaturamentoPorRota = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).slice(0, 12).filter(it => parseFloat(it.valorTotalVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="route" />

  const totalVendas = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  const data = [
    ['Rota', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const pct = totalVendas ? ((venda / totalVendas) * 100).toFixed(1) : '0'
      const label = it.nome || it.rota || '—'
      return [
        label,
        venda,
        tooltipBase(label,
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(Q.Aprov=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}`
        )
      ]
    })
  ]

  const options = {
    pieHole: 0.4,
    colors: CORES_PADRAO,
    tooltip: { isHtml: true },
    legend: { position: 'right', textStyle: { fontSize: 10 } },
    chartArea: { width: '90%', height: '80%' },
    height: 260
  }

  return (
    <Chart chartType="PieChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   5. Tipo de Tarifa (PieChart)
   fonte: bi.totalFaturamentoPorTipoTarifa
─────────────────────────────────────────────*/
export const GraficoTipoTarifa = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => parseFloat(it.valorTotalVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="local_offer" />

  const totalVendas = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  const data = [
    ['Tarifa', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const pct = totalVendas ? ((venda / totalVendas) * 100).toFixed(1) : '0'
      return [
        it.nome,
        venda,
        tooltipBase(it.nome,
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(Q.Aprov=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}<br/>` +
          `<span style="color:#666;">(L.Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        )
      ]
    })
  ]

  const options = {
    pieHole: 0.35,
    colors: CORES_PADRAO,
    tooltip: { isHtml: true },
    legend: { position: 'right', textStyle: { fontSize: 10 } },
    chartArea: { width: '90%', height: '80%' },
    height: 260
  }

  return (
    <Chart chartType="PieChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   6. Excesso de Bagagem (BarChart)
   fonte: bi.totalBagagemPorAtivo
─────────────────────────────────────────────*/
export const GraficoBagagem = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => (it.quantidadeVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="business_center" />

  const data = [
    ['Status', 'Quantidade', { role: 'tooltip', type: 'string', p: { html: true } },
      { role: 'style' }],
    ...lista.map(it => {
      const isAprov = it.nome === 'Aprovadas'
      return [
        it.nome,
        it.quantidadeVendas,
        tooltipBase(it.nome,
          `<span style="color:#666;">(Quantidade=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(it.valorTotalVendas)}<br/>` +
          `<span style="color:#666;">(L.Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        ),
        isAprov ? '#28a745' : '#dc3545'
      ]
    })
  ]

  const options = {
    tooltip: { isHtml: true },
    legend: { position: 'none' },
    hAxis: { textStyle: { fontSize: 11 } },
    vAxis: { textStyle: { fontSize: 11 } },
    chartArea: { width: '70%', height: '70%' },
    height: 220
  }

  return (
    <Chart chartType="ColumnChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   7. Encomendas por Período (ComboChart)
   fonte: bi.totalEncomendaAgrupadoPorPeriodo
─────────────────────────────────────────────*/
export const GraficoEncomendas = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).filter(it => it.periodo)
  if (!lista.length) return <SemDados icone="local_shipping" />

  const data = [
    ['Período', 'Encomendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } },
      'Cancelamentos (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const cancel = parseFloat(it.valorTotalCancelamentos || 0)
      return [
        it.periodo,
        venda,
        tooltipBase(it.periodo,
          `<span style="color:#666;">(Encomendas=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}<br/>` +
          `<span style="color:#666;">(L.Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        ),
        cancel,
        tooltipBase(it.periodo + ' — Cancelamentos',
          `<span style="color:#666;">(Q.Canc.=): </span>${it.quantidadeCancelamentos || 0}<br/>` +
          `<span style="color:#666;">(V.Cancelado=): </span>${formatBRL(cancel)}`
        )
      ]
    })
  ]

  const options = {
    seriesType: 'bars',
    series: { 0: { color: '#17a2b8' }, 1: { type: 'line', color: '#dc3545' } },
    tooltip: { isHtml: true },
    legend: { position: 'top', textStyle: { fontSize: 11 } },
    hAxis: { textStyle: { fontSize: 10 } },
    vAxis: { format: 'short', textStyle: { fontSize: 10 } },
    chartArea: { width: '80%', height: '65%' },
    bar: { groupWidth: '60%' },
    height: 280
  }

  return (
    <Chart chartType="ComboChart" data={data} options={options} width="100%" />
  )
}

/* ────────────────────────────────────────────
   8. Faturamento por Veículo (BarChart horizontal)
   fonte: bi.totalFaturamentoPorVeiculo
─────────────────────────────────────────────*/
export const GraficoFaturamentoPorVeiculo = ({ itens, carregando }) => {
  if (carregando) return <Carregando />
  const lista = (itens || []).slice(0, 10).filter(it => parseFloat(it.valorTotalVendas || 0) > 0)
  if (!lista.length) return <SemDados icone="directions_bus" />

  const totalVendas = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  const data = [
    ['Veículo', 'Vendas (R$)', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...lista.map(it => {
      const venda = parseFloat(it.valorTotalVendas || 0)
      const pct = totalVendas ? ((venda / totalVendas) * 100).toFixed(1) : '0'
      return [
        it.nome || '—',
        venda,
        tooltipBase(it.nome || '—',
          `<span style="color:#666;">(Representa=): </span>${pct}%<br/>` +
          `<span style="color:#666;">(Q.Aprov=): </span>${it.quantidadeVendas || 0}<br/>` +
          `<span style="color:#666;">(Q.Canc.=): </span>${it.quantidadeCancelamentos || 0}<br/>` +
          `<span style="color:#666;">(T.Faturado=): </span>${formatBRL(venda)}<br/>` +
          `<span style="color:#666;">(V.Cancelado=): </span>${formatBRL(it.valorTotalCancelamentos)}<br/>` +
          `<span style="color:#666;">(L.Comissão=): </span>${formatBRL(it.valorTotalComissao)}`
        )
      ]
    })
  ]

  const options = {
    bars: 'horizontal',
    colors: ['#6f42c1'],
    tooltip: { isHtml: true },
    legend: { position: 'none' },
    hAxis: { format: 'short', textStyle: { fontSize: 10 } },
    vAxis: { textStyle: { fontSize: 10 } },
    chartArea: { width: '60%', height: '80%' },
    height: 280
  }

  return (
    <Chart chartType="BarChart" data={data} options={options} width="100%" />
  )
}
